import request from '@/api/request'


// 查询顶层专业
export function getbookMallTab(params) {
  return request({
    url: '/api/book/wdBook/listmagoron',
    params,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
    },
  })
}

// 顶层专业查询子专业和图书
export function getbookMallChildTab(params) {
  return request({
    url: '/api/book/wdBook/listmagorbook',
    params,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
    },
  })
}

// 分页列表查询图书
export function getbookMallList(params) {
  return request({
    url: '/api/book/wdBook/list',
    params,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
    },
  })
}
// 通过id查询
export function getbookMallQuery(id) {
  return request({
    url: '/api/book/wdBook/queryById?id='+id,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
    },
  })
}
// 添加图书到购物车
export function addBookInCart(data) {
  return request({
    url: '/api/shopping/cart/add',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
    },
  })
}



// WEBPACK FOOTER //
// ./src/api/bookMall.js